import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0ad401b2 = () => interopDefault(import('../../../pages/de-de/news/index.vue' /* webpackChunkName: "pages/de-de/news/index" */))
const _3041c6fd = () => interopDefault(import('../../../pages/de-de/rechtsdokumente/index.vue' /* webpackChunkName: "pages/de-de/rechtsdokumente/index" */))
const _ed3cc2f4 = () => interopDefault(import('../../../pages/de-de/rechtswissen/index.vue' /* webpackChunkName: "pages/de-de/rechtswissen/index" */))
const _7a3a4695 = () => interopDefault(import('../../../pages/en-gb/legal-hub/index.vue' /* webpackChunkName: "pages/en-gb/legal-hub/index" */))
const _3411efce = () => interopDefault(import('../../../pages/en-gb/legal-templates/index.vue' /* webpackChunkName: "pages/en-gb/legal-templates/index" */))
const _6a7d45b5 = () => interopDefault(import('../../../pages/en-gb/news/index.vue' /* webpackChunkName: "pages/en-gb/news/index" */))
const _6a27b342 = () => interopDefault(import('../../../pages/fi-fi/asiakirjamallit/index.vue' /* webpackChunkName: "pages/fi-fi/asiakirjamallit/index" */))
const _c798dc4c = () => interopDefault(import('../../../pages/fi-fi/lakitieto/index.vue' /* webpackChunkName: "pages/fi-fi/lakitieto/index" */))
const _e968e1a2 = () => interopDefault(import('../../../pages/fi-fi/uutiset/index.vue' /* webpackChunkName: "pages/fi-fi/uutiset/index" */))
const _b3a9f2f8 = () => interopDefault(import('../../../pages/pl-pl/aktualnosci/index.vue' /* webpackChunkName: "pages/pl-pl/aktualnosci/index" */))
const _94b445d8 = () => interopDefault(import('../../../pages/pl-pl/baza-prawna/index.vue' /* webpackChunkName: "pages/pl-pl/baza-prawna/index" */))
const _2075494a = () => interopDefault(import('../../../pages/pl-pl/szablony/index.vue' /* webpackChunkName: "pages/pl-pl/szablony/index" */))
const _325ee3c6 = () => interopDefault(import('../../../pages/sv-se/dokumentmallar/index.vue' /* webpackChunkName: "pages/sv-se/dokumentmallar/index" */))
const _02b2f8a2 = () => interopDefault(import('../../../pages/sv-se/juridisk-kunskap/index.vue' /* webpackChunkName: "pages/sv-se/juridisk-kunskap/index" */))
const _09c5124a = () => interopDefault(import('../../../pages/sv-se/nyheter/index.vue' /* webpackChunkName: "pages/sv-se/nyheter/index" */))
const _88201658 = () => interopDefault(import('../../../pages/en-gb/legal-templates/all-templates.vue' /* webpackChunkName: "pages/en-gb/legal-templates/all-templates" */))
const _42027ac9 = () => interopDefault(import('../../../pages/fi-fi/asiakirjamallit/kaikki-asiakirjamallit.vue' /* webpackChunkName: "pages/fi-fi/asiakirjamallit/kaikki-asiakirjamallit" */))
const _33fdbc69 = () => interopDefault(import('../../../pages/pl-pl/szablony/wszystkie-wzory.vue' /* webpackChunkName: "pages/pl-pl/szablony/wszystkie-wzory" */))
const _3e6c03a0 = () => interopDefault(import('../../../pages/sv-se/dokumentmallar/alla-dokumentmallar.vue' /* webpackChunkName: "pages/sv-se/dokumentmallar/alla-dokumentmallar" */))
const _221c4b52 = () => interopDefault(import('../../../pages/de-de/rechtswissen/kategorie/_page.vue' /* webpackChunkName: "pages/de-de/rechtswissen/kategorie/_page" */))
const _75efa211 = () => interopDefault(import('../../../pages/en-gb/legal-hub/topic/_page.vue' /* webpackChunkName: "pages/en-gb/legal-hub/topic/_page" */))
const _f4c6b1a8 = () => interopDefault(import('../../../pages/fi-fi/lakitieto/aihe/_page.vue' /* webpackChunkName: "pages/fi-fi/lakitieto/aihe/_page" */))
const _78f39f40 = () => interopDefault(import('../../../pages/pl-pl/baza-prawna/kategorie/_page.vue' /* webpackChunkName: "pages/pl-pl/baza-prawna/kategorie/_page" */))
const _d334ebf8 = () => interopDefault(import('../../../pages/sv-se/juridisk-kunskap/tema/_page.vue' /* webpackChunkName: "pages/sv-se/juridisk-kunskap/tema/_page" */))
const _1c2f98d4 = () => interopDefault(import('../../../pages/de-de/rechtsdokumente/kategorien/_categorySlug/_categoryId.vue' /* webpackChunkName: "pages/de-de/rechtsdokumente/kategorien/_categorySlug/_categoryId" */))
const _caa39d72 = () => interopDefault(import('../../../pages/en-gb/legal-templates/categories/_categorySlug/_categoryId.vue' /* webpackChunkName: "pages/en-gb/legal-templates/categories/_categorySlug/_categoryId" */))
const _47f9b0bb = () => interopDefault(import('../../../pages/fi-fi/asiakirjamallit/kategoriat/_categorySlug/_categoryId.vue' /* webpackChunkName: "pages/fi-fi/asiakirjamallit/kategoriat/_categorySlug/_categoryId" */))
const _310b1f99 = () => interopDefault(import('../../../pages/pl-pl/szablony/kategorie/_categorySlug/_categoryId.vue' /* webpackChunkName: "pages/pl-pl/szablony/kategorie/_categorySlug/_categoryId" */))
const _7628ad0c = () => interopDefault(import('../../../pages/sv-se/dokumentmallar/kategorier/_categorySlug/_categoryId.vue' /* webpackChunkName: "pages/sv-se/dokumentmallar/kategorier/_categorySlug/_categoryId" */))
const _1f9ffe1c = () => interopDefault(import('../../../pages/de-de/news/_article.vue' /* webpackChunkName: "pages/de-de/news/_article" */))
const _1bba39bc = () => interopDefault(import('../../../pages/de-de/rechtswissen/_page.vue' /* webpackChunkName: "pages/de-de/rechtswissen/_page" */))
const _3a08e99e = () => interopDefault(import('../../../pages/en-gb/legal-hub/_page.vue' /* webpackChunkName: "pages/en-gb/legal-hub/_page" */))
const _42fb87a4 = () => interopDefault(import('../../../pages/en-gb/news/_article.vue' /* webpackChunkName: "pages/en-gb/news/_article" */))
const _04f4d676 = () => interopDefault(import('../../../pages/fi-fi/lakitieto/_page.vue' /* webpackChunkName: "pages/fi-fi/lakitieto/_page" */))
const _2e57d82c = () => interopDefault(import('../../../pages/fi-fi/uutiset/_article.vue' /* webpackChunkName: "pages/fi-fi/uutiset/_article" */))
const _23d3e075 = () => interopDefault(import('../../../pages/pl-pl/aktualnosci/_article.vue' /* webpackChunkName: "pages/pl-pl/aktualnosci/_article" */))
const _1e6721b0 = () => interopDefault(import('../../../pages/pl-pl/baza-prawna/_page.vue' /* webpackChunkName: "pages/pl-pl/baza-prawna/_page" */))
const _6b743d3e = () => interopDefault(import('../../../pages/sv-se/juridisk-kunskap/_page.vue' /* webpackChunkName: "pages/sv-se/juridisk-kunskap/_page" */))
const _31581222 = () => interopDefault(import('../../../pages/sv-se/nyheter/_article.vue' /* webpackChunkName: "pages/sv-se/nyheter/_article" */))
const _585d7694 = () => interopDefault(import('../../../pages/de-de/rechtsdokumente/_templateSlug/_templateId.vue' /* webpackChunkName: "pages/de-de/rechtsdokumente/_templateSlug/_templateId" */))
const _58a311b0 = () => interopDefault(import('../../../pages/en-gb/legal-templates/_templateSlug/_templateId.vue' /* webpackChunkName: "pages/en-gb/legal-templates/_templateSlug/_templateId" */))
const _154f8e59 = () => interopDefault(import('../../../pages/fi-fi/asiakirjamallit/_templateSlug/_templateId.vue' /* webpackChunkName: "pages/fi-fi/asiakirjamallit/_templateSlug/_templateId" */))
const _b0845f3e = () => interopDefault(import('../../../pages/pl-pl/szablony/_templateSlug/_templateId.vue' /* webpackChunkName: "pages/pl-pl/szablony/_templateSlug/_templateId" */))
const _943d2498 = () => interopDefault(import('../../../pages/sv-se/dokumentmallar/_templateSlug/_templateId.vue' /* webpackChunkName: "pages/sv-se/dokumentmallar/_templateSlug/_templateId" */))
const _cf56e25a = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _b096c32e = () => interopDefault(import('../../../pages/_country/index.vue' /* webpackChunkName: "pages/_country/index" */))
const _1075e305 = () => interopDefault(import('../../../pages/_country/_page.vue' /* webpackChunkName: "pages/_country/_page" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/de-de/news",
    component: _0ad401b2,
    name: "de-de-news"
  }, {
    path: "/de-de/rechtsdokumente",
    component: _3041c6fd,
    name: "de-de-rechtsdokumente"
  }, {
    path: "/de-de/rechtswissen",
    component: _ed3cc2f4,
    name: "de-de-rechtswissen"
  }, {
    path: "/en-gb/legal-hub",
    component: _7a3a4695,
    name: "en-gb-legal-hub"
  }, {
    path: "/en-gb/legal-templates",
    component: _3411efce,
    name: "en-gb-legal-templates"
  }, {
    path: "/en-gb/news",
    component: _6a7d45b5,
    name: "en-gb-news"
  }, {
    path: "/fi-fi/asiakirjamallit",
    component: _6a27b342,
    name: "fi-fi-asiakirjamallit"
  }, {
    path: "/fi-fi/lakitieto",
    component: _c798dc4c,
    name: "fi-fi-lakitieto"
  }, {
    path: "/fi-fi/uutiset",
    component: _e968e1a2,
    name: "fi-fi-uutiset"
  }, {
    path: "/pl-pl/aktualnosci",
    component: _b3a9f2f8,
    name: "pl-pl-aktualnosci"
  }, {
    path: "/pl-pl/baza-prawna",
    component: _94b445d8,
    name: "pl-pl-baza-prawna"
  }, {
    path: "/pl-pl/szablony",
    component: _2075494a,
    name: "pl-pl-szablony"
  }, {
    path: "/sv-se/dokumentmallar",
    component: _325ee3c6,
    name: "sv-se-dokumentmallar"
  }, {
    path: "/sv-se/juridisk-kunskap",
    component: _02b2f8a2,
    name: "sv-se-juridisk-kunskap"
  }, {
    path: "/sv-se/nyheter",
    component: _09c5124a,
    name: "sv-se-nyheter"
  }, {
    path: "/en-gb/legal-templates/all-templates",
    component: _88201658,
    name: "en-gb-legal-templates-all-templates"
  }, {
    path: "/fi-fi/asiakirjamallit/kaikki-asiakirjamallit",
    component: _42027ac9,
    name: "fi-fi-asiakirjamallit-kaikki-asiakirjamallit"
  }, {
    path: "/pl-pl/szablony/wszystkie-wzory",
    component: _33fdbc69,
    name: "pl-pl-szablony-wszystkie-wzory"
  }, {
    path: "/sv-se/dokumentmallar/alla-dokumentmallar",
    component: _3e6c03a0,
    name: "sv-se-dokumentmallar-alla-dokumentmallar"
  }, {
    path: "/de-de/rechtswissen/kategorie/:page",
    component: _221c4b52,
    name: "de-de-rechtswissen-kategorie-page"
  }, {
    path: "/en-gb/legal-hub/topic/:page?",
    component: _75efa211,
    name: "en-gb-legal-hub-topic-page"
  }, {
    path: "/fi-fi/lakitieto/aihe/:page",
    component: _f4c6b1a8,
    name: "fi-fi-lakitieto-aihe-page"
  }, {
    path: "/pl-pl/baza-prawna/kategorie/:page?",
    component: _78f39f40,
    name: "pl-pl-baza-prawna-kategorie-page"
  }, {
    path: "/sv-se/juridisk-kunskap/tema/:page?",
    component: _d334ebf8,
    name: "sv-se-juridisk-kunskap-tema-page"
  }, {
    path: "/de-de/rechtsdokumente/kategorien/:categorySlug/:categoryId?",
    component: _1c2f98d4,
    name: "de-de-rechtsdokumente-kategorien-categorySlug-categoryId"
  }, {
    path: "/en-gb/legal-templates/categories/:categorySlug?/:categoryId",
    component: _caa39d72,
    name: "en-gb-legal-templates-categories-categorySlug-categoryId"
  }, {
    path: "/fi-fi/asiakirjamallit/kategoriat/:categorySlug/:categoryId?",
    component: _47f9b0bb,
    name: "fi-fi-asiakirjamallit-kategoriat-categorySlug-categoryId"
  }, {
    path: "/pl-pl/szablony/kategorie/:categorySlug/:categoryId?",
    component: _310b1f99,
    name: "pl-pl-szablony-kategorie-categorySlug-categoryId"
  }, {
    path: "/sv-se/dokumentmallar/kategorier/:categorySlug/:categoryId?",
    component: _7628ad0c,
    name: "sv-se-dokumentmallar-kategorier-categorySlug-categoryId"
  }, {
    path: "/de-de/news/:article?",
    component: _1f9ffe1c,
    name: "de-de-news-article"
  }, {
    path: "/de-de/rechtswissen/:page?",
    component: _1bba39bc,
    name: "de-de-rechtswissen-page"
  }, {
    path: "/en-gb/legal-hub/:page?",
    component: _3a08e99e,
    name: "en-gb-legal-hub-page"
  }, {
    path: "/en-gb/news/:article?",
    component: _42fb87a4,
    name: "en-gb-news-article"
  }, {
    path: "/fi-fi/lakitieto/:page?",
    component: _04f4d676,
    name: "fi-fi-lakitieto-page"
  }, {
    path: "/fi-fi/uutiset/:article?",
    component: _2e57d82c,
    name: "fi-fi-uutiset-article"
  }, {
    path: "/pl-pl/aktualnosci/:article?",
    component: _23d3e075,
    name: "pl-pl-aktualnosci-article"
  }, {
    path: "/pl-pl/baza-prawna/:page?",
    component: _1e6721b0,
    name: "pl-pl-baza-prawna-page"
  }, {
    path: "/sv-se/juridisk-kunskap/:page?",
    component: _6b743d3e,
    name: "sv-se-juridisk-kunskap-page"
  }, {
    path: "/sv-se/nyheter/:article?",
    component: _31581222,
    name: "sv-se-nyheter-article"
  }, {
    path: "/de-de/rechtsdokumente/:templateSlug?/:templateId",
    component: _585d7694,
    name: "de-de-rechtsdokumente-templateSlug-templateId"
  }, {
    path: "/en-gb/legal-templates/:templateSlug?/:templateId?",
    component: _58a311b0,
    name: "en-gb-legal-templates-templateSlug-templateId"
  }, {
    path: "/fi-fi/asiakirjamallit/:templateSlug?/:templateId",
    component: _154f8e59,
    name: "fi-fi-asiakirjamallit-templateSlug-templateId"
  }, {
    path: "/pl-pl/szablony/:templateSlug?/:templateId",
    component: _b0845f3e,
    name: "pl-pl-szablony-templateSlug-templateId"
  }, {
    path: "/sv-se/dokumentmallar/:templateSlug?/:templateId",
    component: _943d2498,
    name: "sv-se-dokumentmallar-templateSlug-templateId"
  }, {
    path: "/",
    component: _cf56e25a,
    name: "index"
  }, {
    path: "/:country",
    component: _b096c32e,
    name: "country"
  }, {
    path: "/:country/:page",
    component: _1075e305,
    name: "country-page"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
